package com.rajen.angrejidictionary.presentation.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.rajen.angrejidictionary.analytics.Umami
import com.rajen.angrejidictionary.data.local.AdminAuthManager
import com.rajen.angrejidictionary.data.remote.AdminApi
import com.rajen.angrejidictionary.data.remote.dto.AdminLoginRequest

class AdminLoginViewModel {

    var username by mutableStateOf("")
        private set
    var password by mutableStateOf("")
        private set

    var isLoading by mutableStateOf(false)
        private set
    var errorMessage by mutableStateOf<String?>(null)
        private set
    var loginSuccess by mutableStateOf(false)
        private set

    fun onUsernameChange(value: String) {
        username = value
        errorMessage = null
    }

    fun onPasswordChange(value: String) {
        password = value
        errorMessage = null
    }

    suspend fun login() {
        if (username.isBlank() || password.isBlank()) {
            errorMessage = "Please enter both username and password"
            return
        }

        Umami.trackAdminLoginAttempt()

        isLoading = true
        errorMessage = null

        try {
            val response = AdminApi.login(
                AdminLoginRequest(username.trim(), password)
            )

            if (response.success && response.data != null) {
                AdminAuthManager.saveToken(response.data.token, username.trim())
                Umami.trackAdminLoginSuccess(username.trim())
                loginSuccess = true
            } else {
                errorMessage = response.error?.message ?: "Login failed. Check your credentials."
                Umami.trackAdminLoginError(errorMessage ?: "unknown")
            }
        } catch (e: Exception) {
            errorMessage = "Network error. Please check your connection."
            Umami.trackAdminLoginError("network-error")
        } finally {
            isLoading = false
        }
    }
}